import { render, staticRenderFns } from "./employee-authentication.vue?vue&type=template&id=2c3e8ac6&scoped=true&"
import script from "./employee-authentication.component.ts?vue&type=script&lang=ts&"
export * from "./employee-authentication.component.ts?vue&type=script&lang=ts&"
import style0 from "./employee-authentication.vue?vue&type=style&index=0&id=2c3e8ac6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3e8ac6",
  null
  
)

export default component.exports